import React from 'react';
import PropTypes from 'prop-types';

const NoticeMessage = ({ message }) => (
  <div id="response" className="response_message">
    { message }
  </div>
);

NoticeMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default NoticeMessage;
